<main class="product-detail-page product-detail-page--state" *ngIf="isLoading">
  <header class="site-header" aria-label="S.R.Organic product navigation">
    <a class="brand" routerLink="/" fragment="home" aria-label="S.R. Organic home">
      <span class="brand-mark" aria-hidden="true">🍄</span>
      <strong>S.R.ORGANIC</strong>
    </a>
  </header>

  <section class="detail-state">
    <h1>Loading product...</h1>
    <p>Fetching the latest S.R.ORGANIC product details.</p>
  </section>
</main>

<main class="product-detail-page product-detail-page--state" *ngIf="!isLoading && productNotFound">
  <header class="site-header" aria-label="S.R.Organic product navigation">
    <a class="brand" routerLink="/" fragment="home" aria-label="S.R. Organic home">
      <span class="brand-mark" aria-hidden="true">🍄</span>
      <strong>S.R.ORGANIC</strong>
    </a>

    <nav class="main-nav" aria-label="Primary navigation">
      <a routerLink="/" fragment="home">Home</a>
      <a routerLink="/" fragment="about">About Us</a>
      <a routerLink="/products" class="active">Products</a>
      <a routerLink="/" fragment="why-us">Why Us</a>
      <a routerLink="/" fragment="contact">Contact Us</a>
    </nav>
  </header>

  <section class="detail-state">
    <h1>Product not found.</h1>
    <p>This product may be inactive or unavailable publicly.</p>
    <a class="back-link" routerLink="/products">← All Products</a>
  </section>
</main>

<main class="product-detail-page" *ngIf="product">
  <header class="site-header" aria-label="S.R.Organic product navigation">
    <a class="brand" routerLink="/" fragment="home" aria-label="S.R. Organic home">
      <span class="brand-mark" aria-hidden="true">🍄</span>
      <strong>S.R.ORGANIC</strong>
    </a>

    <nav class="main-nav" aria-label="Primary navigation">
      <a routerLink="/" fragment="home">Home</a>
      <a routerLink="/" fragment="about">About Us</a>
      <a routerLink="/products" class="active">Products</a>
      <a routerLink="/" fragment="why-us">Why Us</a>
      <a routerLink="/" fragment="contact">Contact Us</a>
    </nav>
  </header>

  <section class="detail-hero">
    <div class="detail-copy">
      <a class="back-link" routerLink="/products">
        <span aria-hidden="true">←</span>
        All Products
      </a>
      <h1>{{ product.name }}</h1>
      <p>{{ product.longDescription || product.shortDescription }}</p>
    </div>

    <figure class="detail-media">
      <img [src]="product.imageUrl" [alt]="product.name" />
    </figure>
  </section>

  <section class="detail-content">
    <article class="detail-panel">
      <p class="section-label">Product Overview</p>
      <h2>What this product is made for</h2>
      <p>{{ product.longDescription || product.shortDescription }}</p>
      <p>
        S.R.ORGANIC develops this product stream from mushroom-based organic inputs with a focus on
        consistency, practical use, and responsible circular production.
      </p>
    </article>

    <article class="detail-panel">
      <p class="section-label">Key Details</p>
      <dl class="detail-list">
        <div>
          <dt>Category</dt>
          <dd>{{ product.category }}</dd>
        </div>
        <div>
          <dt>Status</dt>
          <dd>{{ product.status }}</dd>
        </div>
        <div>
          <dt>Product Type</dt>
          <dd>{{ product.type === 'parent' ? 'Product stream' : 'Child product' }}</dd>
        </div>
        <div>
          <dt>Available Variants</dt>
          <dd>{{ childProducts.length || 1 }}</dd>
        </div>
        <div>
          <dt>Slug</dt>
          <dd>{{ product.slug }}</dd>
        </div>
        <div>
          <dt>Display Order</dt>
          <dd>{{ product.displayOrder }}</dd>
        </div>
        <div>
          <dt>Created On</dt>
          <dd>{{ product.createdOn || product.createdAt }}</dd>
        </div>
      </dl>
    </article>

    <article class="detail-panel detail-panel--wide">
      <p class="section-label">Description</p>
      <h2>Complete product details</h2>
      <p><strong>Short description:</strong> {{ product.shortDescription }}</p>
      <p><strong>Long description:</strong> {{ product.longDescription || product.shortDescription }}</p>
    </article>

    <article class="detail-panel detail-panel--wide" *ngIf="childProducts.length">
      <p class="section-label">Child Products</p>
      <h2>Available product variants</h2>
      <div class="child-grid">
        <article *ngFor="let child of childProducts; trackBy: trackByProduct" class="child-card">
          <strong>{{ child.name }}</strong>
          <p>{{ child.longDescription || child.shortDescription }}</p>
        </article>
      </div>
    </article>

    <article class="detail-panel detail-panel--wide">
      <p class="section-label">Applications</p>
      <h2>How customers can use it</h2>
      <div class="application-grid">
        <span>Organic farming inputs</span>
        <span>Soil enrichment</span>
        <span>Wellness and research use cases</span>
        <span>Industrial mushroom by-product programs</span>
      </div>
    </article>

    <article class="detail-panel detail-panel--wide" *ngIf="relatedProducts.length">
      <p class="section-label">Related Products</p>
      <h2>More products in {{ product.category }}</h2>
      <div class="child-grid">
        <a
          *ngFor="let related of relatedProducts; trackBy: trackByProduct"
          class="child-card"
          [routerLink]="['/products', related.id]"
        >
          <strong>{{ related.name }}</strong>
          <p>{{ related.shortDescription }}</p>
        </a>
      </div>
    </article>
  </section>
</main>
